import { useEffect, useState } from 'react';
import { DemonMark } from '../components/DemonMark';
import { useI18n } from './i18n';

export function OfflineState() {
  const { text } = useI18n();
  const [offline, setOffline] = useState(() => typeof navigator !== 'undefined' && !navigator.onLine);

  useEffect(() => {
    const update = () => setOffline(!navigator.onLine);
    window.addEventListener('online', update);
    window.addEventListener('offline', update);
    return () => {
      window.removeEventListener('online', update);
      window.removeEventListener('offline', update);
    };
  }, []);

  if (!offline) return null;
  return (
    <section className="offline-state" role="alert" aria-live="assertive">
      <DemonMark className="offline-state__mark" />
      <p className="eyebrow">{text('offline.eyebrow')}</p>
      <h1>{text('offline.title')}</h1>
      <p>{text('offline.description')}</p>
      <p className="offline-state__hint">{text('offline.retry')}</p>
    </section>
  );
}
